import axios from 'axios';
import config from '../config';

const axiosInstance = axios.create({
  baseURL: config.API_URL.BASE,
  headers: {
    'X-Public-Key': window.ZAPP.PUBLIC_KEY || '',
  }
});

export default axiosInstance;


// WEBPACK FOOTER //
// ./src/api/axiosInstance.js